import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[hsl(var(--ink))] text-[hsl(var(--background))]/80"
    >
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10">
        <div className="grid grid-cols-2 gap-10 sm:grid-cols-6">
          <div className="col-span-2">
            <span className="font-display text-3xl font-semibold text-[hsl(var(--background))]">
              EquiSight
            </span>
            <p className="mt-3 max-w-sm text-sm text-[hsl(var(--background))]/60">
              {t("footer.tagline")}
            </p>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--background))]/45">
              {t("footer.product")}
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/functies" className="hover:text-[hsl(var(--background))]">{t("nav.functies")}</Link></li>
              <li><Link to="/doelgroepen" className="hover:text-[hsl(var(--background))]">{t("nav.doelgroepen")}</Link></li>
              <li><a href="/#pricing" className="hover:text-[hsl(var(--background))]">{t("nav.prijzen")}</a></li>
              <li><Link to="/vergelijkingen" className="hover:text-[hsl(var(--background))]">{t("nav.vergelijkingen")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--background))]/45">
              Gratis tools
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <Link
                  to="/tools/vervoersdocument-paard"
                  data-testid="footer-transport-doc"
                  className="hover:text-[hsl(var(--background))]"
                >
                  Vervoersdocument paard
                </Link>
              </li>
              <li>
                <span className="text-[11px] uppercase tracking-[0.18em] text-[hsl(var(--background))]/35">
                  Binnenkort
                </span>
              </li>
              <li>
                <span className="text-[12px] text-[hsl(var(--background))]/40">
                  Voeding-calculator
                </span>
              </li>
              <li>
                <span className="text-[12px] text-[hsl(var(--background))]/40">
                  Vaccinatie-schema
                </span>
              </li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--background))]/45">
              {t("footer.knowledge")}
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/kennisbank" className="hover:text-[hsl(var(--background))]">{t("nav.kennisbank")}</Link></li>
              <li><Link to="/blog" className="hover:text-[hsl(var(--background))]">{t("nav.blog")}</Link></li>
              <li><Link to="/downloads" className="hover:text-[hsl(var(--background))]">{t("nav.downloads")}</Link></li>
              <li><Link to="/functies/noodnummers" className="hover:text-[hsl(var(--background))]">{t("footer.noodnummers")}</Link></li>
            </ul>
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.22em] text-[hsl(var(--background))]/45">
              {t("footer.company")}
            </p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/over-ons" className="hover:text-[hsl(var(--background))]">{t("nav.overOns")}</Link></li>
              <li><Link to="/contact" className="hover:text-[hsl(var(--background))]">{t("nav.contact")}</Link></li>
              <li><Link to="/support" className="hover:text-[hsl(var(--background))]">{t("nav.support")}</Link></li>
              <li><Link to="/faq" className="hover:text-[hsl(var(--background))]">{t("nav.faq")}</Link></li>
              <li><Link to="/affiliate" data-testid="footer-affiliate" className="hover:text-[hsl(var(--background))]">Partner worden</Link></li>
              <li><Link to="/updates" data-testid="footer-updates" className="hover:text-[hsl(var(--background))]">Wat is nieuw</Link></li>
              <li>
                <a
                  href="https://www.instagram.com/equi.sight/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[hsl(var(--background))]"
                >
                  Instagram
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-[hsl(var(--background))]/50 sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} EquiSight. {t("footer.rightsReserved")}</p>
          <div className="flex flex-wrap gap-5">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-[hsl(var(--background))]">{t("footer.privacy")}</Link>
            <Link to="/voorwaarden" data-testid="footer-terms" className="hover:text-[hsl(var(--background))]">{t("footer.terms")}</Link>
            <Link to="/cookies" data-testid="footer-cookies" className="hover:text-[hsl(var(--background))]">{t("footer.cookies")}</Link>
            <Link to="/sitemap" data-testid="footer-sitemap" className="hover:text-[hsl(var(--background))]">{t("footer.sitemap")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
